import { useContext } from 'react'
import { GlobalContext } from 'context/GlobalContextProvider'
import breakpoints from './breakpoints'

function GetFontSize(fontSizes: any) {
  const { screenDimensions } = useContext(GlobalContext)
  const width = screenDimensions.width

  if (width > breakpoints.desktopLarge) return fontSizes.desktopLarge
  if (width > breakpoints.desktopMid) return fontSizes.desktopMid
  if (width > breakpoints.desktopSmall) return fontSizes.desktopSmall
  if (width > breakpoints.desktopToMobile) return fontSizes.desktopToMobile
  if (width > breakpoints.mobileLarge) return fontSizes.mobileLarge
  if (width > breakpoints.mobileMid) return fontSizes.mobileMid
  if (width > breakpoints.mobileSmall) return fontSizes.mobileSmall
  if (width > breakpoints.mobileSmaller) return fontSizes.mobileSmaller
  return fontSizes.default
}

export function getFontH1() {
  return GetFontSize({
    desktopLarge: '3.5rem', // Hero / Landing headline
    desktopMid: '3rem',
    desktopSmall: '2.5rem',
    desktopToMobile: '2.25rem',
    mobileLarge: '2rem',
    mobileMid: '1.75rem',
    mobileSmall: '1.5rem',
    mobileSmaller: '1.4rem',
    default: '1.4rem'
  })
}

export function getFontH2() {
  return GetFontSize({
    desktopLarge: '2.5rem', // Section headers
    desktopMid: '2.25rem',
    desktopSmall: '2rem',
    desktopToMobile: '1.75rem',
    mobileLarge: '1.5rem',
    mobileMid: '1.375rem',
    mobileSmall: '1.25rem',
    mobileSmaller: '1.125rem',
    default: '1.125rem'
  })
}

export function getFontH3() {
  return GetFontSize({
    desktopLarge: '2rem', // Subsection headers
    desktopMid: '1.75rem',
    desktopSmall: '1.5rem',
    desktopToMobile: '1.375rem',
    mobileLarge: '1.25rem',
    mobileMid: '1.125rem',
    mobileSmall: '1rem',
    mobileSmaller: '0.95rem',
    default: '1rem'
  })
}

export function getFontH4() {
  return GetFontSize({
    desktopLarge: '1.5rem', // Card titles
    desktopMid: '1.375rem',
    desktopSmall: '1.25rem',
    desktopToMobile: '1.125rem',
    mobileLarge: '1rem',
    mobileMid: '0.95rem',
    mobileSmall: '0.9rem',
    mobileSmaller: '0.875rem',
    default: '0.875rem'
  })
}

export function getFontH5() {
  return GetFontSize({
    desktopLarge: '1.25rem', // Small headings, labels
    desktopMid: '1.125rem',
    desktopSmall: '1rem',
    desktopToMobile: '1rem',
    mobileLarge: '0.95rem',
    mobileMid: '0.9rem',
    mobileSmall: '0.875rem',
    mobileSmaller: '0.85rem',
    default: '0.875rem'
  })
}

export function getFontBody() {
  return GetFontSize({
    desktopLarge: '1rem', // Body text
    desktopMid: '1rem',
    desktopSmall: '1rem',
    desktopToMobile: '0.95rem',
    mobileLarge: '0.9rem',
    mobileMid: '0.875rem',
    mobileSmall: '0.85rem',
    mobileSmaller: '0.8rem',
    default: '0.875rem'
  })
}

export function getFontBodySmall() {
  return GetFontSize({
    desktopLarge: '0.8rem', // Body text
    desktopMid: '0.8rem',
    desktopSmall: '0.8rem',
    desktopToMobile: '0.75rem',
    mobileLarge: '0.72rem',
    mobileMid: '0.7rem',
    mobileSmall: '0.7rem',
    mobileSmaller: '0.7rem',
    default: '0.7rem'
  })
}
